export const applicationNameMap = {
  individualMembership: "Individual Membership",
  firmMembership_nonaat: "Firm Application",
  firmMembership_nonaudit: "Firm Application (ACCTECH)",
  duplicateCertificate: "Duplicate Certificate",
  studentApplication: "Student Application",
  trainingemployer: " Training Employer",
  tutionProvider: "Tuition Provider",
  upgradeApplication: "Upgrade Application",
  exemptionCertificate: "Exemption Certificate",
  clearanceCertificate: "Clearance Certificate",
};
